<template lang="pug">
div(class="header-home-page")
    div(class="container-header")
        div(class="d-flex align-items-center" style="gap: 0.75rem;")
            b-img(class=" image-logo" :src="DSG_logo", alt="DSG Logo")
            span(class="version-badge") v{{ appVersion }}
        div(class="message-container" v-if="displayname.value")
            p.d-none.d-md-block Welcome, {{displayname.value}} 
            b-dropdown(size="lg"  variant="link" toggle-class="text-decoration-none" no-caret)
                template(v-slot:button-content)
                    b-icon-person(class="icon-man")
                b-dropdown-item(class="d-md-none d-block") Welcome, {{displayname.value}}
                b-dropdown-item-button(variant="danger" @click="logout") Logout
        div(v-else)
            b-spinner( variant="primary")
            
            
                
            
        
        

</template>

<script>

import DSG_logo from '@/assets/Images/DSG_logo.png';
import authModule from '../store/authenticator';


    export default {
        name: "HeaderHomePage",

        data() {
            return {
            isLocal: false,
            DSG_logo,
            // strip any leading "v" from the env value — the template adds its own
            appVersion: String(process.env.VUE_APP_VERSION || '').replace(/^v/i, ''),
            buttonColor: 'rgb(118, 80, 137)',
            logindata: { ready: false },
            msalApp: null,
            isAdmin: false,
            promptLogin: false,
            }
        },
        methods:{
        async logout(){
            await authModule.removeAccount();
        },
        goToModularForm(){
            
            window.open('https://dsg-form.pages.dev/', '_blank');
        },
        goToRegistrationForm(){
            
            window.open('https://dsg-form.pages.dev/form-response/b0ebf55e-f927-ef11-840b-6045bd58192c/none', '_blank');
        },
        askAndProceed(){
            const checkNotificationPromise = () => {
                try {
                    Notification.requestPermission().then(result => {
                        if(result === "granted"){
                            console.log("Notification permission granted");
                            return true;
                        }
                        if(result === "denied"){
                            console.error("Notification permission denied");
                            return false;
                        }
                    });
                } catch (e) {
                    return false;
                }
                
                return true;
            }
            
            if (checkNotificationPromise()) {
                Notification.requestPermission().then(() => {

                });
            }

            // this.$router.push({path: '/home'});
        },
       
        // async test() {
        //     const {data} = await axios.post('/api/announcement', {});
        //     console.log(data)
        // },
    },
    computed: {
        displayname() {
        return authModule.displayname;
        },
        username() {
        return authModule.username;
        },

    },
    async mounted(){
        // console.log('home init')
        // await authModule.init();
        // await this.$root.init();
        this.isLocal = location.host.includes("localhost");
        this.askAndProceed();
    }
    }
</script>

<style lang="scss" scoped>
.header-home-page {
    background-color: #ffffff;
    color: #343a40;
    height: 10vh;
    width: 100%;
    border-bottom: 1px solid #eceef2;
    box-shadow: 0 1px 6px rgba(63, 30, 84, 0.05);

    .version-badge {
        background-color: #f4f1f8;
        border: 1px solid #e4dcee;
        color: #6b5a80;
        border-radius: 999px;
        padding: 0.1rem 0.6rem;
        font-size: 0.72rem;
        font-weight: 600;
        letter-spacing: 0.02em;
        white-space: nowrap;
    }
    .container-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        width: 80%;
        margin: 0 auto;
        .image-logo {
            width: 150px;
            
        }
        .message-container {
            display: flex;
            align-items: center;
            gap: 1rem;
            p {
                margin: 0 !important;
            }
        }
    }
    .icon-man {
        font-size: 1.5rem;
        color: black;
    }
}
@media (max-width: 768px) {
    .header-home-page {
        .container-header {
            width: 95%;
            .image-logo {
                width: 100px;
            }
        }
    }
}


</style>